import { render, staticRenderFns } from "./NormativaVisualizacao.vue?vue&type=template&id=6e3ebd05&scoped=true"
import script from "./NormativaVisualizacao.vue?vue&type=script&lang=js"
export * from "./NormativaVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./NormativaVisualizacao.vue?vue&type=style&index=0&id=6e3ebd05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ebd05",
  null
  
)

export default component.exports